import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import Router from './router'
import store from './store'
import http from '@/js/http.js'
import common from '@/js/common'
import constants from '@/js/constants'
import user from "@/js/user"
import 'jquery'

import ElementUI from 'element-ui'
import VueResource from 'vue-resource'
import 'element-ui/lib/theme-chalk/index.css'
import VueClipboard from 'vue-clipboard2'
import Vuelidate from 'vuelidate'
import VueBus from 'vue-bus'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import echarts from 'echarts'

Vue.use(Vuex)
Vue.use(VueBus)
Vue.use(ElementUI)
Vue.use(Vuelidate)
Vue.use(VueResource)
Vue.use(VueClipboard)
Vue.use(VueQuillEditor)

Vue.prototype.http = http
Vue.prototype.common = common
Vue.prototype.user = user
Vue.prototype.constants = constants
Vue.prototype.echarts = echarts

Vue.config.productionTip = false

Router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requireAuth)){  // 判断该路由是否需要登录权限
    let flag = window.localStorage.getItem('sessions_key') == null ? false: true
    if(!flag){
      next({
        path: '/',
        // query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    }else{
    	 next();
    }
  }else {
    next();
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: Router ,
  store: store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js